import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Box, Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface IDatePickerFieldProps {
  label: string;
  defaultValue?: Date | null;
  value?: Date | null;
  format: string;
  maxDate?: Date;
  minDate?: Date;
  disablePast?: boolean;
  onChange: (date: Date | null) => void;
  touched?: boolean;
  errors?: string;
  disabled?: boolean;
}

const DatePickerComponent = ({
  label,
  defaultValue,
  value,
  format,
  maxDate,
  minDate,
  disablePast,
  onChange,
  touched,
  errors,
  disabled
}: IDatePickerFieldProps): JSX.Element => {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 500,
          color: '#44474E',
          marginTop: '15px'
        }}
      >
        {label}
      </Typography>
      <Box sx={{ marginTop: '15px' }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            format={format}
            sx={{
              width: '100%'
            }}
            maxDate={maxDate}
            minDate={minDate}
            disablePast={disablePast}
            defaultValue={defaultValue}
            value={value}
            onChange={(event: Date | null) => {
              if (event) {
                onChange(event);
              }
            }}
            disabled={disabled}
          />
        </LocalizationProvider>
      </Box>
      <Typography
        sx={{
          color: 'red',
          fontSize: '10px'
        }}
      >
        {touched && errors}
      </Typography>
    </Box>
  );
};

export default DatePickerComponent;
